import { find, reject, filter, isEmpty } from 'lodash';
import {
    APP_CHANGE_SELECTED_FISCAL_YEAR, 
    APP_SET_HISTORY,
    APP_SET_PARAMS_VALUES, 
    APP_SET_QUERY_VALUE, 
    APP_SET_SEARCH_TERM_VALUE,
    APP_SET_SHOW_IMMEDIATELY, 
    APP_SET_TABULAR_QUERY_VALUE, 
    REQUEST_GET_APIVERSION,
    REQUEST_GET_APIVERSION_ERROR,
    REQUEST_GET_DISEASES_INJURIES, 
    REQUEST_GET_DISEASES_INJURIES_ERROR, 
    REQUEST_GET_DRUGS_TABLE, 
    REQUEST_GET_DRUGS_TABLE_ERROR, 
    REQUEST_GET_EXTERNAL_CAUSES, 
    REQUEST_GET_EXTERNAL_CAUSES_ERROR, 
    REQUEST_GET_METADATA, 
    REQUEST_GET_METADATA_ERROR, 
    REQUEST_GET_NEOPLASMS_TABLE, 
    REQUEST_GET_NEOPLASMS_TABLE_ERROR, 
    REQUEST_GET_TABULAR_DATA, 
    REQUEST_INITIALIZE_GET_DISEASES_INJURIES, 
    REQUEST_INITIALIZE_GET_DRUGS_TABLE, 
    REQUEST_INITIALIZE_GET_EXTERNAL_CAUSES, 
    REQUEST_INITIALIZE_GET_NEOPLASMS_TABLE,
    REQUEST_INITIALIZE_GET_TABULAR_DATA
} from '../actions/constants';

const initialState = {
    apiVersion: {},
    metadata: [],
    selectedFiscalYear: [],
    diseaseInjuries: [],
    diseaseInjuriesCount: null,
    externalCauses: [],
    externalCausesCount: null,
    drugsTable: null,
    drugsTableCount: null,
    neoplasmsTable: null,
    neoplasmsTableCount: null,
    query: '', 
    fy: null ,
    tabularQuery: '',
    tabularData: null,
    externalCausesQueryInProgress: false,
    diseaseInjuriesQueryInProgress: false,
    drugsTableQueryInProgress: false,
    neoplasmsTableQueryInProgress: false,
    errors: [],
    searchTerm: ''
}

const handlers = {
    [APP_SET_PARAMS_VALUES]: (state, { payload }) => {
        return {
            ...state,
            query: payload.query,
            fy: payload.fy
        }
    },
    [REQUEST_GET_APIVERSION]: (state, { payload }) => {
        return {
            ...state,
            apiVersion: payload
        }
    },
    [REQUEST_GET_APIVERSION_ERROR]: (state, { payload }) => {
        const errors = [];
        errors.push({
            status: 500,
            message: `(500) Failed to get API version data`
        })
        return {
            ...state,
            errors
        }
    },
    [REQUEST_GET_METADATA]: (state, { payload }) => {
        const foundFromStateFiscalYear = find(payload.fiscal_years, ['fiscal_year', state.fy]);
        const selectedFiscalYear = foundFromStateFiscalYear ? foundFromStateFiscalYear : payload.fiscal_years[0]
        updateHistory(state.query, selectedFiscalYear.fiscal_year);
        // TODO should maybe reset the fy param if not found
        return {
            ...state,
            metadata: payload,
            selectedFiscalYear: selectedFiscalYear,
            fy: selectedFiscalYear.fiscal_year
        }
    },
    [REQUEST_GET_METADATA_ERROR]: (state, { payload }) => {
        const errors = [];
        errors.push({
            status: 500,
            message: `(500) Failed to make request to get initial application data.`
        })
        return {
            ...state,
            errors
        }
    },
    [APP_CHANGE_SELECTED_FISCAL_YEAR]: (state,  { payload }) => {
        const selectedFiscalYear = find(state.metadata.fiscal_years, ['fiscal_year', payload]);
        updateHistory(state.query, selectedFiscalYear.fiscal_year);
        return {
            ...state,
            selectedFiscalYear,
            fy: selectedFiscalYear.fiscal_year
        }
    },
    [REQUEST_INITIALIZE_GET_DISEASES_INJURIES]: (state) => {
        const diseaseInjuries = []
        const diseaseInjuriesCount = 0;
        return {
            ...state,
            diseaseInjuries,
            diseaseInjuriesCount,
            diseaseInjuriesQueryInProgress: true,
            errors: []
        }
    },
    [REQUEST_GET_DISEASES_INJURIES]: (state, { payload }) => {
        // convert map of maps into a list of maps for easier iteration
        const diseaseInjuries = Object.keys(payload).map( key => {
            const term = key;
            const unfilteredSubterms = Object.keys(payload[key]).map(subkey => {
                if (subkey === 'xrefs') {
                    return ({ term: subkey, values: payload[key][subkey][0]})
                } else {
                    return ({ term: subkey, breadcrumbs: payload[key][subkey].breadcrumbs, xrefs: payload[key][subkey].xrefs ? payload[key][subkey].xrefs : []})
                }
            });
            const subterms = reject(unfilteredSubterms, ['term', 'xrefs']);
            const unformattedXrefs = filter(unfilteredSubterms, ['term', 'xrefs']);
            const xrefs = unformattedXrefs.length > 0 ? unformattedXrefs[0].values : [];
            return ({ term, subterms, xrefs})
        });

        let diseaseInjuriesCount = 0;
        diseaseInjuries.forEach(i => {
            diseaseInjuriesCount++;
            diseaseInjuriesCount += i.subterms.length
        })
        return {
            ...state,
            diseaseInjuries,
            diseaseInjuriesCount,
            diseaseInjuriesQueryInProgress: false
        }
    },
    [REQUEST_GET_DISEASES_INJURIES_ERROR]: (state, { payload }) => {
        const errors = handleError('Diseases and Injuries', payload)
        return {
            ...state,
            diseaseInjuriesQueryInProgress: false,
            errors: state.errors.concat(errors)
        }
    },
    [REQUEST_INITIALIZE_GET_EXTERNAL_CAUSES]: (state) => {
        const externalCauses = []
        const externalCausesCount = 0;
        return {
            ...state,
            externalCauses,
            externalCausesCount,
            externalCausesQueryInProgress: true,
            errors: []
        }
    },
    [REQUEST_GET_EXTERNAL_CAUSES]: (state, { payload }) => {
        // convert map of maps into a list of maps for easier iteration
        const externalCauses = Object.keys(payload).map( key => {
            const term = key;
            const unfilteredSubterms = Object.keys(payload[key]).map(subkey => {
                if (subkey === 'xrefs') {
                    return ({ term: subkey, values: payload[key][subkey][0]})
                } else {
                    return ({ term: subkey, breadcrumbs: payload[key][subkey].breadcrumbs, xrefs: payload[key][subkey].xrefs ? payload[key][subkey].xrefs : []})
                }
            });
            const subterms = reject(unfilteredSubterms, ['term', 'xrefs']);
            const unformattedXrefs = filter(unfilteredSubterms, ['term', 'xrefs']);
            const xrefs = unformattedXrefs.length > 0 ? unformattedXrefs[0].values : [];
            return ({ term, subterms, xrefs})
        });
        let externalCausesCount = 0;
        externalCauses.forEach(i => {
            externalCausesCount++;
            externalCausesCount += i.subterms.length
        })
        return {
            ...state,
            externalCauses,
            externalCausesCount,
            externalCausesQueryInProgress: false
        }
    },
    [REQUEST_GET_EXTERNAL_CAUSES_ERROR]: (state, { payload }) => {
        const errors = handleError('External Causes', payload)
        return {
            ...state,
            externalCausesQueryInProgress: false,
            errors: state.errors.concat(errors)
        }
    },
    [REQUEST_INITIALIZE_GET_DRUGS_TABLE]: (state) => {
        const drugsTable = null;
        const drugsTableCount = 0;
        return {
            ...state,
            drugsTable,
            drugsTableCount,
            drugsTableQueryInProgress: true,
            errors: []
        }
    },
    [REQUEST_GET_DRUGS_TABLE]: (state, { payload }) => {
        // convert map of maps into a list of maps for easier iteration
        const drugsTable = payload
        if (isEmpty(drugsTable)) {
            return {
                ...state,
                drugsTable: null,
                drugsTableCount: 0,
                drugsTableQueryInProgress: false
            }
        }
        drugsTable.table_rows = Object.keys(drugsTable.table_rows).map(rowname => { 
            const rowData = drugsTable.table_rows[rowname]
            return {
                value: rowname,
                codes: rowData.codes,
                breadcrumbs: rowData.breadcrumbs,
                xrefs: rowData.xrefs ? rowData.xrefs : []
            }
        })
        const drugsTableCount = drugsTable.table_rows.length;
        return {
            ...state,
            drugsTable,
            drugsTableCount,
            drugsTableQueryInProgress: false
        }
    },
    [REQUEST_GET_DRUGS_TABLE_ERROR]: (state, { payload }) => {
        const errors = handleError('Drugs Table', payload)
        return {
            ...state,
            drugsTableQueryInProgress: false,
            errors: state.errors.concat(errors)
        }
    },
    [REQUEST_INITIALIZE_GET_NEOPLASMS_TABLE]: (state) => {
        const neoplasmsTable = null;
        const neoplasmsTableCount = 0;
        return {
            ...state,
            neoplasmsTable,
            neoplasmsTableCount,
            neoplasmsTableQueryInProgress: true,
            errors: []
        }
    },
    [REQUEST_GET_NEOPLASMS_TABLE]: (state, { payload }) => {
        // convert map of maps into a list of maps for easier iteration
        const neoplasmsTable = payload;
        if (isEmpty(neoplasmsTable)) {
            return {
                ...state,
                neoplasmsTable: null,
                neoplasmsTableCount: 0,
                neoplasmsTableQueryInProgress: false
            }
        }
        neoplasmsTable.table_rows = Object.keys(neoplasmsTable.table_rows).map(rowname => { 
            const rowData = neoplasmsTable.table_rows[rowname]
            return {
                value: rowname,
                codes: rowData.codes,
                breadcrumbs: rowData.breadcrumbs,
                xrefs: rowData.xrefs ? rowData.xrefs : []
            }
        });
        const neoplasmsTableCount = neoplasmsTable.table_rows.length;
        return {
            ...state,
            neoplasmsTable,
            neoplasmsTableCount,
            neoplasmsTableQueryInProgress: false
        }
    },
    [REQUEST_GET_NEOPLASMS_TABLE_ERROR]: (state, { payload }) => {
        const errors = handleError('Neoplasms', payload)
        return {
            ...state,
            neoplasmsTableQueryInProgress: false,
            errors: state.errors.concat(errors)
        }
    },
    [REQUEST_INITIALIZE_GET_TABULAR_DATA]: (state) => {
        const tabularData = null;
        return {
            ...state,
            tabularData
        }
    },
    [REQUEST_GET_TABULAR_DATA]: (state, { payload }) => {
        const tabularData = payload.tabularData;
        if (isEmpty(tabularData)) {
            return { ...state };
        }
        tabularData.three_digit_category = {
            ...tabularData.three_digit_category,
            code: tabularData.three_digit_category.title.replace(/\s(\S|\s)+$/, '')
        }
        tabularData.subcategories = Object.keys(tabularData.subcategories ? tabularData.subcategories : {}).map(subcategoryName => {
            const data = tabularData.subcategories[subcategoryName]

            return {
                name: subcategoryName,
                instructionTypes: data.instruction_types,
                level: data.level,
                id: makeid(),
                code: subcategoryName.replace(/\s(\S|\s)+$/, '')
            }
        })
        return {
            ...state,
            tabularData: tabularData, 
            tabularQuery: payload.tabularQuery
        }
    },
    [APP_SET_QUERY_VALUE]: (state, { payload }) => {
        return {
            ...state,
            query: payload
        }
    },
    [APP_SET_HISTORY]: (state, { payload }) => {
        updateHistory(payload, state.fy)
        return { ...state }
    },
    [APP_SET_TABULAR_QUERY_VALUE]: (state, { payload, showImmediately }) => {
        return {
            ...state,
            tabularQuery: payload,
            showImmediately
        }
    },
    [APP_SET_SHOW_IMMEDIATELY]: (state, { payload }) => {
        return {
            ...state,
            showImmediately: payload
        }
    },
    [APP_SET_SEARCH_TERM_VALUE]: (state, { payload }) => {
        return {
            ...state,
            searchTerm: payload
        }
    }
}

// TODO where should this go to manage things more cleanly
// needs some cleanup
const updateHistory = (query, fy) => {
    const queryParams = []
    var queryString = ''
    if (fy !== null) {
        queryParams.push(`fy=${fy}`)
    }
    if (query !== null && query.length > 0) {
        queryParams.push(`query=${query}`)
    }
    if (queryParams.length > 0) {
        queryString = `?${queryParams.join('&')}`
    }
    window.history.pushState({}, '', `${queryString}`);
}

const appReducer = (state = initialState, action) => {
    const handler = handlers[action.type];
    return handler ? handler(state, action) : state;
};

const makeid = (length=25) => {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }

 const handleError = (requestType, error) => {
    let errors = []
    if (error.response) {
        errors = error.response.data.errors.map((error) => {
            return {
                message: `${requestType} Request Failed: ${error}`,
                status: error.status
            }
        })
    } else {
        errors.push({
            message: `${requestType} Request Failed`,
            status: 500
        })
    }
    return errors;
 }

export default appReducer;